import React from "react";
import { Card, Col, Row, Tag } from "antd";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import mail from "../../../../assets/images/email.svg";
import Linkedin from "../../../../assets/images/linkedIn.svg";
import Wysisyg from "../../Wysisyg";
import './InfoCard.scss';

const InfoCard = ({ state = {}, jobTypeTitle, disable }) => {

  const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });

  return (
    <motion.div
      className="microsite-info-card-container  spl-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="site-card-border-less-wrapper">
        <Card
          style={{
            // boxShadow:"0px 4px 12px rgba(0, 0, 0, 0.25)",
          }}
          // title={handleCardTitle({ state })}
          bordered={state?.page === "ACCREDITATIONS_AWARDS" ? false : true}
        >
          {state?.page === "ACCREDITATIONS_AWARDS" &&
            <h6 className="title-header">
              {"Award"}
            </h6>
          }

          {state?.page === "news_tab" ? (
            <Wysisyg state={state} />
          ) : (
            <>
              <div className="listInfoBox">
                {(state?.data?.title ||
                  state?.data?.subTitle ||
                  state?.data?.experienceOfWorkTitle) && (
                    <h6 className="title-header title-header-micro ">
                      {(() => {
                        const transformTitle = (title) => {
                          if (title === "WhyDo") {
                            return "Why we exist ?";
                          }
                          if (title === "whatDo") {
                            return "What we do";
                          }
                          if (title === "howDo") {
                            return "How we help customers ?";
                          }
                          return title;
                        };

                        return (
                          transformTitle(state?.data?.title) ??
                          state?.data?.subTitle ??
                          state?.data?.experienceOfWorkTitle
                        );
                      })()}
                    </h6>
                  )}
                {(state?.data?.description ||
                  state?.data?.experienceOfWorkOpportunityOutput
                    ?.description) && (
                    <div
                      // style={{
                      //   textIndent: "60px",
                      //   whiteSpace: "pre-wrap",
                      //   margin: "0",
                      // }}
                      className="micro-descrp"
                      style={{

                      }}
                    >
                      <p>
                        {state?.data?.description ??
                          state?.data?.experienceOfWorkOpportunityOutput
                            ?.description}
                      </p>
                    </div>
                  )}
              </div>
            </>
          )}

          {state?.page === "apprenticeship" || state?.page === "vacancy" ? (
            <div className="listInfoBox">
              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol">
                    <p className="pointer-headers">
                      {state?.page === "apprenticeship"
                        ? "Apprenticeship type:"
                        : "Vacancy type:"}
                    </p>
                  </div>
                  <div className="listInfoCol">
                    <p>
                      {state?.data?.apprenticeshipType === "PART_TYPE"
                        ? "Part Time"
                        : "Full Time"}
                    </p>
                  </div>
                </div>


              </div>

              {state?.data?.jobTypeEnum &&
                jobTypeTitle(state?.data?.jobTypeEnum) && (
                  <div className="type pointers">
                    <div className="listInfoRow">
                      <div className="listInfoCol"><p className="pointer-headers">Job type:</p></div>
                      <div className="listInfoCol"><p>{jobTypeTitle(state?.data?.jobTypeEnum)}</p></div>
                    </div>


                  </div>
                )}

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="pointer-headers">Compensation:</p></div>
                  <div className="listInfoCol"><p>{state?.data?.compensation}</p></div>
                </div>


              </div>

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="pointer-headers">Compensation type:</p></div>
                  <div className="listInfoCol">
                    <p>
                      {state?.data?.compensationType === "ANNUALLY"
                        ? "Annually"
                        : "Annually"}
                    </p>
                  </div>
                </div>


              </div>

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"> <p className="pointer-headers">Closing date:</p></div>
                  <div className="listInfoCol"> <p>{state?.data?.closingDate}</p></div>
                </div>


              </div>

              <div
                className="type skills"
                style={{ display: "flex", alignItems: "center", marginBottom:'10px'}}
              >
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="skillsLabel pointer-headers">Skills:</p></div>
                  <div className="listInfoCol">
                    <div className="skillTags">
                      {state?.data?.skills.map((skill) => (
                        <Tag style={{marginBottom: '10px'}} color="red" key={skill.name}>
                          {skill.name}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </div>


              </div>
            </div>
          ) : null}

          {state?.page === "contract" && (
            <div>
              {state?.data?.procurementReference && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Procurement Reference:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.procurementReference}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.postalCode && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Postal code:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.postalCode}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.valueOfContract !== 0 && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Value Of Contract:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.valueOfContract}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.startDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Start date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.startDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.endDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">End date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.endDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.closeDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Close date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.closeDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.closeTime && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Close time:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.closeTime}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.contractType && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Contract Type:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.contractType}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.email && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Email:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.email}</p></div>
                  </div>


                </div>
              )}
            </div>
          )}

          {(state?.page === "OUR_TEAM" || state?.page === "OUR_CLIENT") &&
            state?.data?.aboutUsTeamDataOutPut?.linkedin && (
              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol labelCol">
                    <div className="labelContent">
                      <img src={Linkedin} alt="LinkedIn" className="icon" />
                      <span className="pointer-headers">LinkedIn:</span>
                    </div>
                  </div>
                  <div className="listInfoCol valueCol">
                    <a
                      className="anchor"
                      href={state?.data?.aboutUsTeamDataOutPut?.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {state?.data?.aboutUsTeamDataOutPut?.linkedin}
                    </a>
                  </div>
                </div>
              </div>
            )}

            {(state?.page === "OUR_TEAM" || state?.page === "OUR_CLIENT") &&
              state?.data?.aboutUsTeamDataOutPut?.email && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol labelCol">
                      <div className="labelContent">
                        <img src={mail} alt="Email" className="icon" />
                        <span className="pointer-headers">Email:</span>
                      </div>
                    </div>
                    <div className="listInfoCol valueCol">
                      <a
                        className="anchor"
                        href={`mailto:${state?.data?.aboutUsTeamDataOutPut?.email}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {state?.data?.aboutUsTeamDataOutPut?.email}
                      </a>
                    </div>
                  </div>
                </div>
              )}

          <div style={{ display: "flex", justifyContent: "end" }}>
            {state?.page === "apprenticeship" || state?.page === "vacancy" ? (
              <div className="apply-btn">
                <a
                  href={state?.data?.urlLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {state?.data?.urlLink && (
                    <button disabled={disable} className="applyButton"
                      style={{ marginTop: isSmallScreen && "10px" }}
                    >
                      Apply
                    </button>
                  )}
                </a>
              </div>
            ) : null}

            {/* {state?.page !== "about-us" && (
              <div className="phone-icon">
                <Button
                  //   disabled={disable}
                  className="call-btn"
                  onClick={phoneHandler}
                >
                  <img src={callIcon} alt="Call" />
                </Button>
              </div>
            )}

            {state?.data?.urlLink || state?.data?.webLink ? (
              <div className="phone-icon">
                <Button
                  className="call-btn"
                  // icon={<LinkOutlined />}
                  onClick={LinkHandler}
                >
                  <img src={LinkOutlined} alt="LinkOutlined" />
                </Button>
              </div>
            ) : null} */}
          </div>
        </Card>
      </div>
    </motion.div>
  );
};

export default InfoCard;